import React from 'react';
import CheckboxGroupPresenter, {
  Props as PresenterProps
} from './CheckboxGroupPresenter';

interface Props
  extends Pick<
    PresenterProps,
    'value' | 'options' | 'gridContainerProps' | 'gridItemProps'
  > {
  onChange: (value: string[]) => void;
}

const CheckboxGroupContainer: React.FC<Props> = (props) => {
  const onChange = (
    e: React.ChangeEvent<HTMLInputElement>,
    checked: boolean
  ) => {
    const m_value = checked
      ? [...props.value, e.target.name]
      : props.value.filter((item) => item !== e.target.name);
    return props.onChange(m_value);
  };

  return <CheckboxGroupPresenter {...props} onChange={onChange} />;
};

export default CheckboxGroupContainer;

CheckboxGroupContainer.defaultProps = {
  value: [''],
  gridContainerProps: {
    justify: 'space-between',
    wrap: 'wrap'
  }
};
